import React, { useState } from "react";
import { upload } from "@/services/api/Career";
import { Input } from "../ui/input";

const FileUpload = ({ fileUrl, setFileUrl }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // const handleDrop = async (e) => {
  //   e.preventDefault();
  //   const file = e.dataTransfer.files[0];
  //   setFile(file);
  //   const url = await uploadFile(file, 'uploads/job_applies');
  //   console.log(url); // do something with the URL
  // }

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const uploadFile = async (file, folder) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("filepond", file);
    formData.append("folder", folder);

    const response = await upload(formData);
    setLoading(false);
    return response.data.url;
  };

  const handleFileChange = async (e) => {
    setFileUrl("");
    const file = e.target.files[0];
    setFile(file);
    const url = await uploadFile(file, "uploads/job_applies");
    setFileUrl(url);
  };

  return (
    <>
      {fileUrl && !loading ? (
        <div>
          <a
            className='block py-2 text-sm font-medium text-center text-white truncate border rounded-md shadow-sm bg-background border-background/10'
            rel='noopener noreferrer'
            href={fileUrl}
            target='_blank'
          >
            View CV
          </a>
          <button
            onClick={() => setFileUrl("")}
            className='mt-1 text-xs font-medium text-red-500 hover:text-red-400'
          >
            Remove File
          </button>
        </div>
      ) : (
        <Input
          type='file'
          onChange={handleFileChange}
          className='bg-white cursor-pointer ring-offset-white border-background/20'
        />
      )}
      {loading && <p>Uploading, Please wait...</p>}
    </>
  );
};

export default FileUpload;
